import React, { SyntheticEvent, useState } from 'react';
import { Box, Tab, Tabs} from '@mui/material';
import RequestReports from './RequestReports';
import ShipmentReports from './ShipmentReports';
import InventoryReports from './InventoryReports';
import RemainingInventoryReports from './RemainingInventoryReports';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export function ReportContainer() {
  const [value, setValue] = useState<number>(0);

  const handleChange = (event: SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box width='100%'>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange}>
          <Tab label='Requests' {...a11yProps(0)} />
          <Tab label='Shipments' {...a11yProps(1)} />
          <Tab label='Inventory' {...a11yProps(2)} />
          <Tab label='Months of Remaining Inventory' {...a11yProps(3)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <RequestReports />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <ShipmentReports />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <InventoryReports />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <RemainingInventoryReports />
      </CustomTabPanel>
    </Box>
  );
}
